import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../environments/environment';

// Only redirect to /access-denied when the /api/me membership check itself
// refuses. Any other endpoint's 403 (including a transient token/DB blip that
// happens to surface the same UserResolverService message) should stay as an
// error, not evict a valid user from the app.
const ACCESS_DENIED_MARKER = 'is not authorised for this application';
const MEMBERSHIP_CHECK_URL = `${environment.apiBaseUrl}/api/me`;

export const accessDeniedInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  if (!req.url.startsWith(environment.apiBaseUrl)) return next(req);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (
        error instanceof HttpErrorResponse &&
        error.status === 403 &&
        req.url === MEMBERSHIP_CHECK_URL
      ) {
        const message =
          (error.error as { message?: string } | null)?.message ?? '';
        if (message.includes(ACCESS_DENIED_MARKER)) {
          router.navigate(['/access-denied']);
        }
      }
      return throwError(() => error);
    })
  );
};
